module.exports = __webpack_public_path__ + "static/media/badge_declined.f32a8fd0.svg";